import PropTypes from 'prop-types';
import React from 'react';
import {
    NotificationSeverity,
    ProgressState,
} from '@Data/notifications/Interfaces';
import NotificationItem from './NotificationItem';
import NotificationProgressIndicator from './NotificationProgressIndicator';

const SequentialNotificationItem = (props) => {
    const { remaining, total, severity, message, onCancel, id } = props;

    const completed = total - remaining;

    const innerHtml = (
        <NotificationProgressIndicator
            progress={(completed / total) * 100}
            message={`${message}: ${completed}/${total} completed`}
            state={ProgressState.PENDING}
        />
    );

    return (
        <NotificationItem
            id={id}
            message={innerHtml}
            severity={severity}
            hideIcon={severity !== NotificationSeverity.SUCCESS}
            onCancel={onCancel}
        />
    );
};

SequentialNotificationItem.propTypes = {
    remaining: PropTypes.number,
    total: PropTypes.number,
    severity: PropTypes.any,
    message: PropTypes.string,
    onCancel: PropTypes.func,
    id: PropTypes.string,
};
export default SequentialNotificationItem;
